import React from "react";
import { Box, Flex, Image, Text } from "@chakra-ui/react";
import HeaderDropdown from "components/dropdown";

const Topbar = ({ title }) => {
  return (
    <Box>
      <Flex bg="white" padding={8} align={"center"} justify={"space-between"}>
        <Flex alignItems={"center"}>
          <Text
            fontFamily={"PlusJakartaSansBold"}
            fontSize={"16px"}
            lineHeight={"16px"}
            textTransform={"uppercase"}
            color={"#000000"}
          >
            {title}
          </Text>
          <Image
            src={require("assets/svgs/info-circle.svg").default}
            pos={"relative"}
            bottom={"1px"}
            mx={2}
            _hover={{
              cursor: "pointer",
            }}
          />
        </Flex>
        <HeaderDropdown />
      </Flex>
    </Box>
  );
};

export default Topbar;
